/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// material
import Copy from 'material/copy/copy';
import Title from 'material/copy/title/title';
import CTAs from 'material/ctas/ctas';
import OrganizeContentCTA from 'material/ctas/organizecontent/organizecontent_container';
import ContentCard from 'material/embeds/contentcard/contentcard_container';
import Pagination from 'material/pagination/pagination';
// drag and drop
// https://github.com/atlassian/react-beautiful-dnd
// https://codesandbox.io/s/ql08j35j3q
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
// utils
import { isContentValid } from 'utils/embeds/content_validation';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/management/customize/contentselector/contentselector_styles';



/* ========== ~~~~~~~~~~ CONTENT SELECTOR : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class ContentSelector extends Component {
    constructor(props) {
        super(props);
        this.itemsPerPage = 10;
        this.state = {
            position: 0,
            contentLive: this.getItems(this.props.contents, 0)
        };
        this.handleClick = this.handleClick.bind(this);
        this.onDragEnd = this.onDragEnd.bind(this);
        this.reorder = this.reorder.bind(this);
    }

    componentDidUpdate(prevProps) {

        // only scroll the container if we've added a new content
        if (Object.keys(prevProps.contents).length < Object.keys(this.props.contents).length) {
            this.scrollContentSelector();
        }
        //rearrange numbers
        if(JSON.stringify(this.props.contents) !== JSON.stringify(prevProps.contents)){
                //moved this check in to this statement because they both would be fired when content changed in the reducer
                //this ternary will check if we have no content at our current position after a delete and
                // if not it will try moving back one position if we are not at the first position (0)
                //this is important because when manipulating content on the organize component those changes need to reflect
                //within the content selector, these two components are active at the same time
                // so this one needs to be listening for all changes in content
                this.getItems(this.props.contents, this.state.position).length === 0 ?
                    this.setState({contentLive:this.getItems(this.props.contents, this.state.position-10), position: this.state.position === 0 ? this.state.position : (this.state.position-this.itemsPerPage) })
                    : this.setState({contentLive: this.getItems(this.props.contents, this.state.position)});
        }

        if(this.props.noLiveContents !== prevProps.noLiveContents && this.props.noLiveContents) {
            this.props.sendMessage('Your embed has NO content! ' +
                'Your embed will have ONLY ' +
                'alternate revenue generating features ' +
                'like Market Research and Profiling ' +
                'Questions (as seen on the revenue tab)  ' +
                'Click “Preview” to see how it looks.')
        }
    }
    handleClick(contentId) {
        const isValid = isContentValid(this.props.selectedContent);
        if(isValid) {
            this.props.selectContent(contentId);
        } else {
            this.props.invalidateSelectedContent();
            this.props.sendMessage('There are required fields you must fill out before continuing.');
        }
    }
    showPlacement() {
        return this.props.location === 'in-content' ? 'incontent' : 'rail';
    }
    scrollContentSelector(el = document.querySelector('.cardcontainer')) {
        return el.scrollLeft = el.scrollWidth;
    }
    getItems = (contents, position) => {
        let contentCards = [];
        for (let contentId of Object.keys(contents)) {
            if(this.props.contents[contentId].contentLive === true) {
                contentCards.push({
                    id: `${contentId}`,
                    number: contents[contentId]['queuePosition'] + 1,
                    queuePosition: contents[contentId]['queuePosition'],
                    type: contents[contentId]['contentType'],
                    title: contents[contentId]['title'],
                    options: contents[contentId]['options'],
                    content: <ContentCard contentId={contentId}
                                          isClickable={true}
                                          processClick={() => this.handleClick(contentId)}
                                          key={this.props.contents[contentId].type + contentId}
                                          type={this.props.contents[contentId].contentType} size={`small`}
                                          number={this.props.contents[contentId]['queuePosition'] + 1} />
                })
            }
        }
        contentCards.sort(function(a,b) {return (a.queuePosition > b.queuePosition) ? 1 : ((b.queuePosition > a.queuePosition) ? -1 : 0);} );
        if(contentCards.length === 0){
            this.props.updateNoLiveContent(true);
        }
        return position >= 0 ? contentCards.slice(position, position+this.itemsPerPage) : contentCards;
    };
    reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    };
    onDragEnd = result => {
        const { source, destination } = result;
        if (!destination || destination.index === source.index) { return; } // dropped outside the list
        const contentLive = this.reorder(
            this.getItems(this.props.contents),
            source.index,
            destination.index
        );
        this.setState({contentLive:contentLive});
        this.props.reorderContents(contentLive,[]);
    };

    renderPagination=()=>{
        if(!this.props.noLiveContents){
            return this.getItems(this.props.contents).length > this.itemsPerPage && <div className={`pagination`}>
                <Pagination
                    handlePrevious={this.handlePrev}
                    handleNext={this.handleNext}
                    itemsPerPage={this.itemsPerPage}
                    totalItems={this.getItems(this.props.contents).length}
                    currentIndex={this.state.position + 10}/>
            </div>
        }
    };
    handlePrev = ()=> this.state.position === 0 ? null : this.setState({position: this.state.position - 10, contentLive: this.getItems(this.props.contents, this.state.position - 10)});
    handleNext = ()=> this.setState({position: this.state.position + 10, contentLive: this.getItems(this.props.contents, this.state.position + 10)});
    render() {
        return(
            <div className={`contentselector ${this.props.classes.contentselector} ${this.showPlacement()}`}>
                <Copy>
                    <Title>
                        <h5>Your Embed</h5>
                        <p>Drag to reorder, select page to edit content</p>
                    </Title>
                    <CTAs>
                        <OrganizeContentCTA />
                    </CTAs>
                </Copy>
                 <DragDropContext onDragEnd={this.onDragEnd} >
                    <Droppable droppableId="droppable" direction="horizontal">
                        {(provided, snapshot) => (
                            <div
                                className={`cardcontainer droppable isDraggingOver-${snapshot.isDraggingOver} ${this.props.noLiveContents ? 'greyOut' : '' }`}
                                ref={provided.innerRef}>
                                {/* Check if the id of the contentLive item exists in the application state. This is a patch. */}
                                {/* TODO: Move the live contents list to the component level. */}
                                {this.state.contentLive.map((item, index) => Object.keys(this.props.contents).includes(item.id) ? (
                                    <Draggable
                                        key={item.id}
                                        draggableId={item.id}
                                        index={index + this.state.position}>
                                        {(provided, snapshot) => (
                                            <div
                                                className={`contentcard draggable isDragging-${snapshot.isDragging}`}
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                style={provided.draggableProps.style}>
                                                {item.content}
                                            </div>
                                        )}
                                    </Draggable>
                                ) : null)}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
                {this.renderPagination()}
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(ContentSelector);
